export default __webpack_public_path__ + "static/media/19.34752a7b.jpg";